export enum SecurityAccessEnum {
  Granted = 1,
  Overridable = 2,
  Denied = 3,
}
